import { render, staticRenderFns } from "./StudyStatistician.vue?vue&type=template&id=6233298c&"
import script from "./StudyStatistician.vue?vue&type=script&lang=js&"
export * from "./StudyStatistician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports